var styles = {"box":"Pagination_box_1v5et_1","box__inner":"Pagination_box__inner_1v5et_15","info":"Pagination_info_1v5et_22","progress":"Pagination_progress_1v5et_37","btn":"Pagination_btn_1v5et_55"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
